/* eslint-disable arrow-body-style */
/**
 * @description defines routes for the personnel sync form page
 */

import React from 'react';

import PersonnelSync from '@seccon/pages/personnelSync';

export default [
  {
    path: '/personnel/sync',
    element: (
      <PersonnelSync />
    )
  }
];
